const PERKS = [
  {
    icon: '🏨',
    title: 'Medical Insurance',
    content: 'Company sponsored plan available.'
  },
  {
    icon: '💻',
    title: 'Equipment',
    content: 'A budget for your own computer.'
  },
  {
    icon: '✈️',
    title: 'Team Trip',
    content: 'Annual company trip.'
  },
  {
    icon: '🍽',
    title: 'Lunch',
    content: 'Weekly team lunches.'
  },
  {
    icon: '🏙',
    title: 'Location',
    content: 'Our office is in heart of NYC.'
  },
  {
    icon: '🏢',
    title: 'Office',
    content: 'Stocked with snacks and beverages.'
  }
]

export default PERKS
